import React from "react";
import { copyIframeCode } from "./SelectWidgetLanguage.utils";
import { SelectWidgetLanguageProps } from "./SelectWidgetLanguage.types";
import "./SelectWidgetLanguage.style.css";
import {
  SupportedLanguages,
  SupportedLanguagesSymbols,
} from "../WidgetTab.constants";
import { getIframeCode } from "../WidgetTab.utils";
import { SupportedLanguagesEntries } from "./SelectWidgetLanguage.constants";

const SelectWidgetLanguage: React.FC<SelectWidgetLanguageProps> = ({
  t,
  setIframeCode,
  iframeCode,
  widgetId,
}) => {
  const handleCopyIframeCodeBtn = (langSymbol: string) => {
    const newIframeCode = getIframeCode(widgetId, langSymbol);
    setIframeCode(newIframeCode);
    copyIframeCode(newIframeCode, t);
  };

  return (
    <div className="iframe-copy-btns-container">
      {SupportedLanguagesEntries.map(([key, langSymbol]) => (
        <button
          key={key}
          className="iframe-copy-btn"
          onClick={() => {
            handleCopyIframeCodeBtn(langSymbol);
          }}
          disabled={!Boolean(iframeCode.length)}
        >
          <span className="iframe-copy-btn-main-text">{t("codeCopyBtn")}</span>
          <span className="iframe-copy-btn-secondary-text">
            {t("defaultWidgetLanguage", {
              language: t(SupportedLanguages[key]),
            })}
          </span>
        </button>
      ))}
    </div>
  );
};

export default React.memo(SelectWidgetLanguage);
